import React from "react";

export const MessengerIcon = () => {
  return (
    <svg width="72" height="71" viewBox="0 0 72 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3705_107218)">
        <path
          d="M36.1673 70.78C55.7127 70.78 71.5573 54.9354 71.5573 35.39C71.5573 15.8446 55.7127 0 36.1673 0C16.622 0 0.777344 15.8446 0.777344 35.39C0.777344 54.9354 16.622 70.78 36.1673 70.78Z"
          fill="#007FFF"
        />
        <path
          d="M37.9409 39.0797L34.2525 35.1375L27.0478 39.0797L34.9775 30.6697L38.7566 34.6119L45.8706 30.6697L37.9409 39.0797ZM36.5 21C28.4887 21 22 27.0084 22 34.4216C22 38.6447 24.1116 42.4147 27.4013 44.8797V50L32.3403 47.2903C33.6544 47.6528 35.05 47.8522 36.5 47.8522C44.5113 47.8522 51 41.8438 51 34.4306C51 27.0175 44.5113 21 36.5 21Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3705_107218">
          <rect width="70.78" height="70.78" fill="white" transform="translate(0.777344)" />
        </clipPath>
      </defs>
    </svg>
  );
};
